import React from 'react';
import styled from 'react-emotion';
import { LoadingLine } from '@jetshop/ui/Loading/LoadingLine';
import Layout from '../Layout/Layout';

const Wrapper = styled.div`
  display: flex;
  ${p => p.theme.below.md} {
    flex-direction: column;
  }
  margin-bottom: 20px;
`;

const Lines = styled.div`
  display: flex;
  flex-direction: column;

  ${p => p.theme.above.md} {
    margin-left: 1rem;
  }
`;

const Image = styled.div`
  width: 50%;
  position: relative;
  background: #f5f5f5;
  padding-bottom: 50%;

  ${p => p.theme.below.md} {
    width: 75%;
    padding-bottom: 75%;
    margin: 0 auto;
    margin-bottom: 20px;
  }

  &::before {
    content: '';
    position: absolute;
    padding-bottom: 100%;
  }
`;

const StyledLine = styled(LoadingLine)`
  margin-bottom: 1rem;
`;

const ProductPagePlaceholder = () => (
  <Layout>
    <Wrapper>
      <Image />
      <Lines>
        <StyledLine heightPx={33} widthRem={10} randomizeWidthBy={2} />
        <StyledLine heightPx={54} widthRem={5} />
        <StyledLine heightPx={120} widthRem={20} />
        <StyledLine
          count={12}
          widthRem={32}
          heightPx={16}
          randomizeWidthBy={5}
        />
      </Lines>
    </Wrapper>
  </Layout>
);

export default ProductPagePlaceholder;
